var App = App || {};

App.Alerts = (function ($) {
    'use strict';

    function Init() {
        var alerts = $("#Alerts").find(".alert");

        alerts.each(function (index, alert) {
            var $alert = $(alert),
                $alertCollapse = $alert.find(".btn-collapse"),
                guid = $alert.data("guid"),
                cookieName = `AmerisBank_Alert_${guid}`;

            $alertCollapse.on("click", function () {
                var $collapseButton = $(this);

                ToggleCollapse($alert, $collapseButton, cookieName);
            });

            $alert.on("closed.bs.alert", function () {
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            })

            if ($alertCollapse.attr("aria-expanded") == "true") {
                $alert.find(".carousel-navigation").removeClass("collapsed");
            }

            InitCarousel($(this));
        });
    }

    function ToggleCollapse($alert, $collapseButton, cookieName) {
        if ($collapseButton.attr("aria-expanded") == "false") {
            $collapseButton.attr("aria-expanded", "true");

            $alert
                .removeClass("collapsed")
                .attr("role", "alert")
                .find(".carousel-navigation").removeClass("collapsed");

            App.Cookies.setItem(cookieName, "Collapsable", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
        else {
            $collapseButton.attr("aria-expanded", "false");

            $alert
                .addClass("collapsed")
                .attr("role", null)
                .find(".carousel-navigation").addClass("collapsed");

            App.Cookies.setItem(cookieName, "Collapsed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        }
    }

    function InitCarousel(alert) {
        const carousel = alert.find(".alert-carousel.splide");
        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                gap: "5px",
                drag: false,
                snap: false,
                perMove: 1
            });

            splideCarousel.on("ready active resized", function () {
                carousel.find(".splide__slide a").attr("tabindex", -1);

                setTimeout(function () {
                    carousel.find(".splide__slide.is-visible a").attr("tabindex", 0);
                }, 10);
            });

            const indexDisplay = alert.find(".splide__counter-current");
            const totalDisplay = alert.find(".splide__counter-total");

            splideCarousel.on('mounted', function () {
                totalDisplay.text(splideCarousel.length);
                indexDisplay.text(splideCarousel.index + 1);
            });

            splideCarousel.on('move', function (newIndex) {
                indexDisplay.text(newIndex + 1);
            });

            splideCarousel.mount();

            const nextBtn = alert.find(".carousel-btn.carousel-next");
            const prevBtn = alert.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go("+1");
            });

            prevBtn.on("click", function () {
                splideCarousel.go("-1");
            });

            //if alert is collapsed on load, slides have incorrect proportions. This is fixed after a move
            var parentAlert = carousel.parents(".alert");
            if (parentAlert.length) {
                var collapseBtn = parentAlert.find(".btn.btn-collapse")
                if (collapseBtn.length) {
                    collapseBtn.on("click", function () {
                        splideCarousel.go("+1");
                        splideCarousel.go("-1");
                    });
                }
            }
        }
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.Alerts.Init();
});